export const SURF_GRAPHIC_ICON_IDS = [
    "dot",
    "star",
    "check",
    "arrow",
    "circle",
    "diamond",
    "bolt",
    "heart",
];
const TEMPLATES = new Set([
    "list",
    "process",
    "cycle",
    "pyramid",
    "comparison",
]);
export function emptyGraphicData(template = "list") {
    return {
        template,
        items: [
            { label: "Primo punto", sublabel: "Dettaglio", icon: "dot" },
            { label: "Secondo punto", sublabel: "Dettaglio", icon: "star" },
            { label: "Terzo punto", sublabel: "Dettaglio", icon: "check" },
        ],
    };
}
export function normalizeGraphicData(data) {
    const template = TEMPLATES.has(data.template) ? data.template : "list";
    const items = (data.items ?? [])
        .map((item) => normalizeGraphicItem(item))
        .filter((item) => item.label.length > 0);
    return {
        template,
        items: items.length ? items : emptyGraphicData(template).items,
    };
}
function normalizeGraphicItem(item) {
    const iconRaw = String(item.icon ?? "dot").trim();
    const icon = SURF_GRAPHIC_ICON_IDS.includes(iconRaw) ? iconRaw : "dot";
    return {
        label: String(item.label ?? "").trim(),
        sublabel: String(item.sublabel ?? "").trim() || undefined,
        icon,
    };
}
export function getLayerGraphic(layer) {
    const raw = layer.style?.graphic;
    if (!raw || typeof raw !== "object")
        return emptyGraphicData();
    return normalizeGraphicData(raw);
}
export function setLayerGraphic(layer, graphic) {
    return {
        ...layer,
        style: { ...layer.style, graphic: normalizeGraphicData(graphic) },
    };
}
export function setGraphicTemplate(data, template) {
    return normalizeGraphicData({ ...data, template });
}
export function setGraphicItem(data, index, patch) {
    const next = normalizeGraphicData(data);
    if (index < 0 || index >= next.items.length)
        return next;
    next.items[index] = normalizeGraphicItem({ ...next.items[index], ...patch });
    return next;
}
export function addGraphicItem(data) {
    const next = normalizeGraphicData(data);
    next.items.push({ label: `Elemento ${next.items.length + 1}`, icon: "dot" });
    return normalizeGraphicData(next);
}
export function removeGraphicItem(data, index) {
    const next = normalizeGraphicData(data);
    if (next.items.length <= 1)
        return next;
    next.items.splice(index, 1);
    return normalizeGraphicData(next);
}
export function moveGraphicItem(data, index, delta) {
    const next = normalizeGraphicData(data);
    const target = index + delta;
    if (index < 0 || index >= next.items.length || target < 0 || target >= next.items.length)
        return next;
    const tmp = next.items[index];
    next.items[index] = next.items[target];
    next.items[target] = tmp;
    return normalizeGraphicData(next);
}
export function graphicLayerFromData(graphic, partial) {
    return {
        type: "graphic",
        x: 0.52,
        y: 0.15,
        w: 0.42,
        h: 0.7,
        z: partial?.z ?? 30,
        rotation: 0,
        content: "",
        style: { graphic: normalizeGraphicData(graphic) },
        ...partial,
    };
}
export function slideTextForGraphicCompose(slide) {
    const parts = slide.layers
        .filter((l) => l.type === "text")
        .map((l) => l.content.replace(/^•\s*/, "").trim())
        .filter(Boolean);
    if (slide.speakerNotes?.trim())
        parts.push(slide.speakerNotes.trim());
    return parts.join("\n");
}
export function graphicAccentColors(theme, count) {
    const base = [theme.palette.accent, theme.palette.text, theme.palette.muted, theme.palette.surface];
    return Array.from({ length: count }, (_, i) => base[i % base.length]);
}
